<div class="migration-success flex flex-column center gap-30">
  <img src="assets/images/svg/migration-success-icon.svg" alt="" width="101" height="97" />
  <div class="title">
    {{ 'Success!' | translate }}
  </div>
  <div class="sub-title" [innerHTML]="'Your account has been migrated.' | translate"></div>
  <div
    class="description"
    [innerHTML]="'Click below to sign in using your email address and new password.' | translate"
  ></div>
  <app-button [label]="'button.Login' | translate" (click)="this.handleLogin()" />
</div>
